// extracted by mini-css-extract-plugin
export default {"container":"editable-data_container__QHZwU","content":"editable-data_content__CFmOd","field":"editable-data_field__h63JX","buttons":"editable-data_buttons__nwneP"};